<template>
  <div class="dashboard-main-content-wrapper">
    <div>
      <Controls
        :voucher-templates="voucherTemplates['Invoice']"
        :displayed-components="displayedComponents"
        :used-template="usedTemplate"
        @displayChanged="updateVisibility($event)"
        @templateChanged="updateUsedTemplate($event)"
        @previewInvoice="previewInvoice"
        @resetInfo="applyNewTemplate()" />
      <InvoiceForm
        :invoice="invoice"
        :currency-tenants="currencyTenants"
        :invoice-fees="invoiceFees"
        :voucher-template="usedTemplate"
        :customers="customers"
        :displayed-components="displayedComponents"
        :selected-invoice-fee="selectedInvoiceFee"
        :invoice-preview-built="invoicePreviewBuilt"
        @displayChanged="updateVisibility($event)"
        @updateSelectedInvoiceFee="updateSelectedInvoiceFee($event)"
        @formSubmit="createFormSubmitted($event)"
        @formChanged="toggleChanges($event)" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapMutations } from "vuex";

import store from "./InvoiceStore";
import VoucherTemplateStore from "../VoucherTemplates/VoucherTemplateStore";
import Controls from "./InvoiceForm/Controls.vue";
import InvoiceForm from "./InvoiceForm/InvoiceForm.vue";
import InvoiceMixin from "./InvoiceMixin";
import InvoiceFormMixin from "./InvoiceForm/InvoiceFormMixin";
import CustomerStore from "../Customer/CustomerStore";
import TenantStore from "@tenant_admin/stores/TenantStore";
import TaxStore from "@dashboard/stores/TaxStore";
import CompanyStore from "@shared/components/Company/CompanyStore";

const responseStore = {
  response: {
    resource: {
      due_date: null,
      invoice_resource: {},
      description: {},
      line_items: [],
      currency_id: null
    }
  },
  paymentMethods: null,
  currencyTenants: null,
  invoiceFee: null,
  customers: [],
  voucherTemplates: []
};

const fetchResource = async (to, from, next) => {
  responseStore.currencyTenants = await TenantStore.methods.fetchVisibleCurrencyTenants(
    Dashboard.currentTenant.id,
    CompanyStore.currentCompany.country.id
  );

  responseStore.invoiceFees = await TenantStore.methods.fetchFees(
    Dashboard.currentTenant.id
  );

  responseStore.customers = await CustomerStore.fetchAll();

  responseStore.voucherTemplates = await VoucherTemplateStore.fetchAll(
    { companyId: CompanyStore.currentCompany.id });

  responseStore.taxes = await TaxStore.filteredWithEmptyTax(CompanyStore.currentCompany.id);

  next();
};

export default {
  name: "InvoiceNew",

  title () {
    return `New Invoice - ${Dashboard.currentTenant.name}`;
  },

  components: {
    Controls,
    InvoiceForm
  },

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  mixins: [InvoiceMixin, InvoiceFormMixin],

  data: function () {
    return {
      store: store,
      responseStore: this.$_.cloneDeep(responseStore),
      company: CompanyStore.currentCompany,
      invoicePreviewBuilt: false
    };
  },

  computed: {
    currencyTenants () {
      return this.responseStore.currencyTenants;
    },

    taxes () {
      return this.responseStore.taxes.collection;
    },

    invoiceFees () {
      return this.responseStore.invoiceFees.filter(
        (fee) => fee.service === "Invoicing"
      );
    },

    customers () {
      return this.responseStore.customers.collection;
    },

    voucherTemplates () {
      return this.$_.groupBy(this.responseStore.voucherTemplates.collection,
        "voucher_type");
    }
  },

  mounted () {
    this.setBreadcrumb("New Invoice");
  },

  created () {
    this.updateTaxes(this.taxes);
    this.resetState();
  },

  methods: {
    ...mapMutations("lineItems", [
      "resetState"
    ]),

    ...mapMutations("instruments", [
      "updateTaxes"
    ]),

    initializeUsedTemplate () {
      this.usedTemplate = this.voucherTemplates["Invoice"].find((template) => template.default);
    },

    async createFormSubmitted (e) {
      tinyMCE.triggerSave();
      this.handleResponseToShow(await store.create());
    },

    handleResponseToShow (response) {
      if (response.success) {
        this.formChanged = false;
        this.navigateToShowRoute(response);
        this.notifySuccess(response.successMessage);
        this.company.invoices_count++;
      } else {
        this.notifyErrors(response.errorMessages);
      }
    },

    navigateToShowRoute (response) {
      this.$router.push({
        name: "Show Invoice",
        params: {
          hash: response.resource.path_token
        }
      });
    },

    previewInvoice () {
      this.invoicePreviewBuilt = true;
    },

    toggleChanges (e) {
      this.formChanged = e;
    }
  }
};
</script>
